import { Text } from '@acast/decibel';
import Croppie from 'croppie';
import T from 'prop-types';
import React, { Component } from 'react';
import Modal from 'shared/components/modal';

class Crop extends Component {
  componentDidMount() {
    const croppie = new Croppie(this.croppingPane, {
      viewport: { width: 200, height: 200 },
      boundary: { width: 300, height: 300 },
      showZoomer: false,
      mouseWheelZoom: false,
    });

    croppie.bind({
      url: this.props.url,
      zoom: 0,
    });

    this.props.croppieRef(croppie);
  }

  render() {
    return (
      <div
        ref={ref => {
          this.croppingPane = ref;
        }}
      />
    );
  }
}

class CropDialog extends Component {
  applyCrop = () => {
    this.croppie
      .result({
        format: 'jpg',
        type: 'blob',
        size: 'original',
      })
      .then(result => {
        this.props.onDismiss(result);
      })
      .catch(() => {
        this.props.onDismiss();
      });
  };

  render() {
    return (
      <Modal
        title="Crop Image"
        onDismiss={shouldCrop => shouldCrop && this.applyCrop()}
        dialog={
          <>
            <Crop
              url={this.props.url}
              croppieRef={ref => {
                this.croppie = ref;
              }}
            />
            <Text>
              Note: once cropping is applied it cannot be undone. To adjust, re-upload the original
              image.
            </Text>
          </>
        }
        actions={[{ name: 'Apply Cropping', value: true, variant: 'primary' }]}
      />
    );
  }
}

CropDialog.propTypes = {
  onDismiss: T.func,
  url: T.string.isRequired,
};

CropDialog.defaultProps = {
  onDismiss: () => {},
};

export default CropDialog;
